exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-5193f8d1] {\n  top: 20px;\n  left: 50% !important;\n  transform: translateX(-50%);\n}\n", ""]);

// exports
